module.exports = __webpack_public_path__ + "static/media/Photo5.047bdb7a.jpg";